import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        products: {}
    },
    mutations: {
        setProducts(state, products) {
            const result = Object.assign({}, state.products);
            products.forEach(product => {
                result[product.id] = product;
            });
            Vue.set(state, 'products', result);
        }
    },
};
